export default __webpack_public_path__ + "static/media/download-icon.35ded0b2.svg";